<template>
    <img src="/docuvault_logo.webp" alt="Docu-Vault" class="mr-3" style="max-height: 15vh" />
</template>
